<!--
 * @Author: etong
 * @Date: 2021-07-02 15:46:33
 * @LastEditTime: 2024-07-23 17:02:05
 * @LastEditors: yangtao yangtao@shjinjia.com.cn
 * @Description:
 * @FilePath: \oak\src\components\CommonSearch\search.vue
 * Think first, Program later
-->
<template>
  <div class="filter-container">
    <AdvancedSearch ref="advancedSearch" v-bind="searchConfig" class="filter-item" @clearQuery="clearQuery">
      <div slot="searchHeader">
        <jj-form-no-item
          v-for="item in searchConfig['searchHeaderList']"
          :key="item.key"
          :item="item"
          v-bind="item"
          :value="value[item.key]"
          :style="{'min-width':columnMinWidth}"
          @input="handleInput($event, item)"
          @keyup.enter.native="handleFilter"
        />
        <slot name="customSearchHeader"></slot>
      </div>
      <div slot="searchButton" class="searchButton">
        <div v-if="searchConfig['searchHeaderList']&&searchConfig['searchHeaderList'].length>0&&isShowSearchBtnDetailsByTabs">
          <el-button
            type="primary"
            icon="el-icon-search"
            class="filter-item primary-btn hasIcon-btn"
            @click="handleFilter"
          />
        </div>
        <div>
          <el-button
            v-if="searchConfig['searchButton']&&searchConfig['searchButton']['isCreateCheck']&&(previewPermissionCheck||($route.meta&&checkPermissionByMeta('createPower',$route.meta.page_functions)))=='9'"
            v-waves
            class="filter-item primary-btn hasIcon-btn"
            round
            type="primary"
            icon="el-icon-plus"
            @click="handleCreate(searchConfig['searchButton']&&searchConfig['searchButton']['createOptions'])"
          >{{ searchConfig['searchButton']&&
            searchConfig['searchButton']['createOptions']['label'] || '新建' }}</el-button>
          <el-button
            v-if="searchConfig['searchButton']&&searchConfig['searchButton']['isShowImport']&&(previewPermissionCheck||($route.meta&&checkPermissionByMeta('createPower',$route.meta.page_functions)))=='9'"
            v-waves
            class="filter-item hasIcon-btn"
            round
            type="default"
            icon="el-icon-upload2"
            @click="handleImport"
          >{{ (searchConfig && searchConfig['searchButton'] && searchConfig['searchButton']['importOptions'] && searchConfig['searchButton']['importOptions']['label']) || '导入' }}</el-button>
          <slot name="listTopRightOprSlots"></slot>
          <el-button
            v-if="searchConfig['searchButton']&&searchConfig['searchButton']['isShowExport']&&(previewPermissionCheck||($route.meta&&checkPermissionByMeta('exportPower',$route.meta.page_functions)))=='9'"
            v-waves
            :loading="exportLoading"
            class="filter-item hasIcon-btn"
            round
            type="default"
            icon="el-icon-download"
            @click="handleExport"
          >{{ (searchConfig && searchConfig['searchButton'] && searchConfig['searchButton']['exportOptions'] && searchConfig['searchButton']['exportOptions']['label']) || '导出' }}</el-button>
        </div>
      </div>
      <!-- 表格得查询条件 -->
      <div slot="searchList" class="filter-container lowcodeSearchList">
        <jj-form v-if="searchConfig['searchList']" ref="searchForm" v-model="searchListValue" :form-config="searchConfig['searchList']" />
      </div>
    </AdvancedSearch>
  </div>

</template>

<script>
import AdvancedSearch from '@/components/AdvancedSearch'
import waves from '@/directive/waves' // Waves directive
import Apis from '@/api/commonPage/commonList.js'
import checkPermissionByMeta from '@/utils/permissionByMeta' // 权限判断函数
import { cloneDeep, isArray } from 'lodash'

export default {
  name: 'CommonSearch',
  components: {
    AdvancedSearch
  },
  directives: {
    waves
  },
  props: {
    // 外部传进来的code
    modelCode: {
      type: String,
      default: ''
    },
    // 搜索组件配置
    // 主配置 继承advancedSearch属性
    // searchHeader <Array> 外部展示搜索条件
    // searchButton 目前支持 搜索 导入 导出 新建
    // searchButton {isCreateCheck} 是否可以新建 新建的条件
    // searchButton {isShowImport} 是否可以导入
    // searchButton {isShowExport} 是否可以导出
    // searchList <Object> 收缩起来的搜索条件
    searchConfig: {
      type: Object,
      required: true
    },
    // 搜索组件值
    value: {
      type: Object,
      required: true
    },
    // 最小的宽度
    columnMinWidth: {
      type: String
    },
    // 外部传进来的docmodel
    docModelProp: {
      type: String,
      default: ''
    },
    // 外部传递进来的module
    moduleProp: {
      type: String,
      default: ''
    },
    // 导出loading状态
    exportLoading: {
      type: Boolean,
      default: false
    },
    // 多标签页是否显示搜索按钮
    isShowSearchBtnDetailsByTabs: {
      type: Boolean,
      default: false
    },
    isFromOtherDetail: {
      type: [String, Boolean],
      default: undefined
    },
    // 是否为预览模式
    isPreviewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchListValue: {}, // 下拉框搜索的筛选数据
      csvFlag: false, // 导出
      queryName: ''
    }
  },
  computed: {
    // 是否采用 code代替docModel
    isCodeVersion: function() {
      const { path } = this.$route
      return path && path.indexOf('V2') >= 0
    },

    // 预览模式下的权限检查：统一返回9（有权限）
    previewPermissionCheck() {
      return this.isPreviewMode ? '9' : null
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        if (newVal) {
          Object.assign(this.searchListValue, newVal)
        }
      },
      deep: true,
      immediate: true
    },
    searchListValue: {
      handler: function(newVal, oldVal) {
        if (newVal) {
          this.$emit('input', { ...this.value, ...newVal })
        }
      },
      deep: true,
      immediate: true
    },
    $route: {
      handler: function() {
        // Route changed - could be used for future enhancements
      },
      immediate: true,
      deep: true
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    !this.isFromOtherDetail && this.setDefaultValue()
  },
  destroyed() {},
  methods: {
    checkPermissionByMeta,
    /**
     * @description: 清空搜索条件
     * @param {*}
     * @return {*}
     */
    clearQuery() {
      this.$emit('clearQuery')
    },
    /**
     * @description: 将查询参数值传递出去
     * @param {*}
     * @return {*}
     */
    handleFilter() {
      this.$emit('handleFilter')
    },
    /**
     * @description: 往外部抛值
     * @param {*} val
     * @param {*} key
     * @return {*}
     */
    handleInput(val, item) {
      const { key, type } = item
      this.$emit('input', { ...this.value, [key]: type === 'input' ? val.trim() : val })
    },
    /**
     * @description: 设置默认值
     * @param {*}
     * @return {*}
     */
    setDefaultValue() {
      // 设置默认值
      if (this.searchConfig) {
        this.searchConfig['searchHeaderList'] && this.deepValue(this.searchConfig['searchHeaderList'])
        this.searchConfig['searchList'] && this.searchConfig['searchList']['formItemList'] &&
        this.deepValue(this.searchConfig['searchList']['formItemList'])
        // 设置默认值结束
        this.$emit('setDefaultValueCallBack')
      }
    },
    /**
     * @description: 对对象 拆出属性进行赋值
     * @param {*} Arr
     * @return {*}
     */
    // deepValue(Arr) {
    //   const formData = this.value
    //   Arr && Arr.forEach(item => {
    //     const { key, value, type } = item
    //     if (formData[key] === undefined || formData[key] === null) {
    //       if (type === 'date' && item['value-format'] && value) {
    //         formData[key] = this.$moment(value).format(item['value-format'])
    //       } else {
    //         formData[key] = isArray(value) ? value : ('' + value).trim()
    //       }
    //     }
    //   })
    //   this.$emit('input', { ...formData })
    // },
    deepValue(Arr) {
      // const formData = { ...this.value }
      const formData = this.value
      Arr && Arr.forEach(item => {
        const { key, value, type } = item
        if (formData[key] === undefined && type !== 'number' || formData[key] === null) {
          // 🎯 简化：移除日期处理逻辑，由JJForm/item.vue统一处理
          formData[key] = isArray(value) ? value : ('' + value).trim()
        }
      })
      const formDataCp = cloneDeep(formData)
      this.$emit('input', { ...formDataCp })
    },

    /**
     * @description: 新建
     * @param {*}
     * @return {*}
     */
    handleCreate() {
      const options = this.searchConfig['searchButton'] && this.searchConfig['searchButton']['createOptions']
      this.$router.push({
        path: options['url'],
        query: {
          t: +new Date(),
          parent_t: this.$route.query.t,
          type: 1, // 1 新增 2 修改 3 查看 4复制
          backPath: this.$route.path || ''
        }
      })
    },
    /**
     * @description: 导出
     * @param {*}
     * @return {*}
     */
    handleExport() {
      this.$emit('handleExport')
    },
    handleImport() {
      this.$emit('handleImport')
    },
    getExportDocModel() {
      if (this.searchConfig['searchButton']) {
        const { code } = this.searchConfig['searchButton']['exportOptions']
        if (code) {
          Apis.GetQueryInfo({
            queryCode: code
          }).then(response => {
            if (+response.data.res_status_code === 0) {
              const { res_content } = response.data
              if (res_content) {
                const { docModel, queryName } = res_content
                this.queryName = queryName
                return {
                  docModel,
                  queryName
                }
              } else {
                return {}
              }
            } else {
              this.$message({
                type: 'error',
                message: response.data.res_message
              })
            }
          })
        }
      }
    }

  } // 生命周期 - 销毁完成
}
</script>
<style lang='scss' scoped>
.advancedBtn {
  .filter-item:not(:last-child) {
    margin-right: 5px;
  }
}

.lowcodeSearchList {
  /deep/.el-form-item--mini.el-form-item {
    margin-bottom: 10px;
    width: 100%;
  }
}
</style>
